import { lazy } from 'react';
import { Redirect } from 'react-router-dom';

const AppRoutes = [
  {
    path: "/health-insurances",
    exact: true,
    component: lazy(() =>
      import("../../components/pages/healthInsurances/list/index")
    ),
  },
  {
    path: "/health-insurances",
    exact: true,
    component: lazy(() =>
      import("../../components/pages/healthInsurances/list")
    ),
  },
  {
    path: "/health-insurances/add",
    exact: true,
    component: lazy(() =>
      import("../../components/pages/healthInsurances/add")
    ),
  },
  {
    path: "/health-insurances/edit/:id",
    exact: true,
    component: lazy(() =>
      import("../../components/pages/healthInsurances/edit")
    ),
  },
  {
    path: "/patients",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/list")),
  },
  {
    path: "/patients/add",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/add")),
  },
  {
    path: "/patients/timeline/:id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline")),
  },
  {
    path: "/patients/timeline/show/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/custom/show")),
  },
  {
    path: "/patients/timeline/denver/show/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/denver/show")),
  },
  {
    path: "/patients/timeline/denver/show/chart/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/denver/show/chart")),
  },
  {
    path: "/patients/timeline/ablls/show/chart/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/ablls/show/chart")),
  },
  {
    path: "/patients/timeline/denver/show/chart/comparative/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/denver/show/chart/comparative")),
  },
  {
    path: "/patients/timeline/ablls/show/chart/comparative/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/ablls/show/chart/comparative")),
  },
  {
    path: "/patients/timeline/ablls/show/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/ablls/show")),
  },
  {
    path: "/patients/timeline/vbMapp/show/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/vbMapp/show")),
  },
  {
    path: "/patients/timeline/vbMapp/show/chart/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/vbMapp/show/chart")),
  },
  {
    path: "/patients/timeline/pei/show/:id/:patient_id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/timeline/pei")),
  },
  {
    path: "/patients/edit/:id",
    exact: true,
    component: lazy(() => import("../../components/pages/patients/edit")),
  },
  {
    path: "/apps/calendar",
    exact: true,
    component: lazy(() => import("components/pages/calendar")),
  },
  {
    path: "/waiting-room",
    exact: true,
    component: lazy(() => import("../../components/pages/waitingrooms")),
  },
  {
    path: "/appointment/:id/:waiting_room",
    exact: true,
    component: lazy(() => import("../../components/pages/appointmentV2")),
  },
  {
    path: "/daily-evaluation/",
    exact: true,
    component: lazy(() => import("../../components/pages/dailyEvaluation")),
  },
  {
    path: "/daily-evaluation/show/:id/:patientId/:templateId",
    exact: true,
    component: lazy(() => import("../../components/pages/dailyEvaluation/form")),
  },
  {
    path: "/appointment/engine",
    exact: true,
    component: lazy(() => import("../../components/pages/appointment")),
  },
  {
    path: "/prescriptions/",
    exact: true,
    component: lazy(() => import("../../components/pages/prescriptions")),
  },
  {
    path: "/users/",
    exact: true,
    component: lazy(() => import("../../components/pages/users/list")),
  },
  {
    path: "/users/edit/:id",
    exact: true,
    component: lazy(() => import("../../components/pages/users/edit")),
  },
];

export default AppRoutes;